export const MOBILE_MAX_SCREEN_SIZE = 680;
